export enum DeviceStatusTypes {
  Active = 1,
  Offline = 2,
  PendingConfiguration = 4,
  LogRequests = 8,
  HiddenDevice = 16,
  Registered = 32,
}
